export default __webpack_public_path__ + "static/media/seven.e2bc718d.png";